/* Starting layouts. White's nine pieces; Black mirrors them by a 180 degree rotation (D1). Row index 0 = row 1 = White's back rank. */
import type { Layout } from './position.ts';
import { OCTAGON, RHOMBUS, SQUARE, TRIANGLE } from './types.ts';

/** The v2 layout (magnetic-v2.html). 18 of 40 first moves harm the mover's own pieces; kept for comparison runs only. */
export const LAYOUT_V2: Layout = [
  { shape: SQUARE, r: 0, c: 0 }, { shape: RHOMBUS, r: 0, c: 2 }, { shape: OCTAGON, r: 0, c: 4 }, { shape: RHOMBUS, r: 0, c: 6 }, { shape: SQUARE, r: 0, c: 8 },
  { shape: TRIANGLE, r: 1, c: 1 }, { shape: TRIANGLE, r: 1, c: 7 }, { shape: TRIANGLE, r: 2, c: 3 }, { shape: TRIANGLE, r: 2, c: 5 },
];

/**
 * D8 layout, chosen by the user 2026-09-03: the mirror-symmetric layout closest to the original v2 setup that
 * satisfies the D8 constraints (found by packages/sim/src/layout-nearby.ts, distance 4).
 *
 *   3  .  .  . t  o  t  .  .  .
 *   2  . t   .  .  .  .  . t  .
 *   1  . s  r  .  .  .  r  s  .
 *
 * Compared with the original: the squares come in off the corners (A1/I1 -> B1/H1) and the Core steps up from E1 to E3
 * between the forward triangles. Everything else is unchanged. No first move by either side pushes or drops the mover's
 * own piece, no + face points at an adjacent board edge, the Core is two rows off the edge.
 */
export const LAYOUT_V3: Layout = [
  { shape: OCTAGON, r: 2, c: 4 },
  { shape: SQUARE, r: 0, c: 1 }, { shape: SQUARE, r: 0, c: 7 },
  { shape: RHOMBUS, r: 0, c: 2 }, { shape: RHOMBUS, r: 0, c: 6 },
  { shape: TRIANGLE, r: 1, c: 1 }, { shape: TRIANGLE, r: 1, c: 7 },
  { shape: TRIANGLE, r: 2, c: 3 }, { shape: TRIANGLE, r: 2, c: 5 },
];

export const LAYOUT: Layout = LAYOUT_V3;
